/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeagueCategory } from '../models/LeagueCategory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LeagueCategoryService {
    /**
     * Get League Categories
     * @returns LeagueCategory Successful Response
     * @throws ApiError
     */
    public static getLeagueCategoriesLeagueCategoryGet(): CancelablePromise<Array<LeagueCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/league_category/',
        });
    }
}
